/** A block as read for its practice clozes: a cloze carries `qid` and `practice`, any block may hold `children`. */
type PracticeNode = { readonly id: string; readonly type: string; readonly qid?: unknown; readonly practice?: unknown; readonly children?: unknown }

/** The `.practice` clozes and questions under `children` (a rule's or question group's content), in document order. */
export function practiceClozes<T extends PracticeNode>(children: readonly T[]): (T & { qid: string })[] {
  return children.flatMap((block): (T & { qid: string })[] => {
    if ((block.type === 'cloze' || block.type === 'question') && block.practice === true && typeof block.qid === 'string') return [block as T & { qid: string }]
    return Array.isArray(block.children) ? practiceClozes(block.children as T[]) : []
  })
}

/**
 * Inside a rule every `.practice` cloze is one question, so all of them carry one qid: the first practice cloze's, in
 * document order, among the `settled` ones (a writer's unchanged clozes; default all), else the first one's.
 * Undefined when the rule holds no practice cloze.
 */
export function rulePracticeQid<T extends PracticeNode>(children: readonly T[], settled: (cloze: T) => boolean = () => true): string | undefined {
  const clozes = practiceClozes(children)
  return (clozes.find(cloze => settled(cloze)) ?? clozes[0])?.qid
}
